var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDropdown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 17,
    viewBox: "0 0 30 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6602 16.8623C14.8704 16.8623 15.0697 16.8236 15.2578 16.7461C15.457 16.6576 15.6286 16.5358 15.7725 16.3809L28.6221 3.21582C28.9209 2.91699 29.0703 2.56283 29.0703 2.15332C29.0703 1.86556 29.0039 1.60547 28.8711 1.37305C28.7383 1.14062 28.5557 0.958008 28.3232 0.825195C28.1019 0.692383 27.8473 0.625977 27.5596 0.625977C27.1501 0.625977 26.7904 0.769857 26.4805 1.05762L13.7637 14.0566H15.54L2.82324 1.05762C2.52441 0.769857 2.16471 0.625977 1.74414 0.625977C1.45638 0.625977 1.19629 0.692383 0.963867 0.825195C0.742513 0.958008 0.56543 1.14062 0.432617 1.37305C0.299805 1.60547 0.233398 1.86556 0.233398 2.15332C0.233398 2.36361 0.272135 2.56283 0.349609 2.75098C0.427083 2.92806 0.53776 3.08854 0.681641 3.23242L13.5312 16.3809C13.8633 16.7018 14.2396 16.8623 14.6602 16.8623Z",
    fill: "black",
    fillOpacity: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdown);
export default __webpack_public_path__ + "static/media/dropdown.56022ac1b371e6b47b95fb920f47a5ca.svg";
export { ForwardRef as ReactComponent };